import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {NamedEntity} from '../@types/global'

export interface IWorkspaceState extends NamedEntity {
    colors: {
        primary: string
        secondary: string
        textColor: string
    }
    is_active: number
    images: {
        favicon: string
        logo: string
    }
}

export const initialWorkspaceState: IWorkspaceState = {
    id: '',
    name: 'MyWebforce',
    colors: {
        primary: '#0094f3',
        secondary: '#e1006d',
        textColor: '#fff',
    },
    is_active: 0,
    images: {
        favicon: '',
        logo: '',
    },
}

export const actionTypes = {
    SetWorkspace: '[SET_WORKSPACE] Action',
    ClearWorkspace: '[CLEAR_WORKSPACE] Action',
}

// Create actions
export const actions = {
    setWorkspace: (workspace: IWorkspaceState) => ({
        type: actionTypes.SetWorkspace,
        payload: workspace,
    }),
    clearWorkspace: () => ({type: actionTypes.ClearWorkspace}),
}


export const reducer = persistReducer(
    {storage, key: 'v100-demo1-workspace', whitelist: ['id', 'name', 'colors', 'is_active', 'images']},
    (state: IWorkspaceState = initialWorkspaceState, action: any) => {
        switch (action.type) {
            case actionTypes.SetWorkspace: return {...state, ...action.payload}
            case actionTypes.ClearWorkspace: return initialWorkspaceState
            default: return state
        }
    },
)
